// extracted by mini-css-extract-plugin
export default {"slide-item":"ooUda","slide-card":"Wn9aB","slide-image":"K7mCW","slide-text":"DWb6q"};